module.exports = __webpack_public_path__ + "static/for-organizations-eb3bc1824f9a72b20d89b8a9f9cea59a.png";